import { Col } from "antd";
import { CadastroCardNavigation, IconSVG, Text } from "../styles";

type CadastroCardProps = {
    color: string;
    Icon?: any;
    text: string;
    onClick: () => void;
    dataTestId?: string;
};

export default function CadastroCard({ color, Icon, text, onClick, dataTestId }: CadastroCardProps) {
    return (
        <Col
            xl={6}
            lg={8}
            md={12}
            sm={24}
            style={{ display: "flex", justifyContent: "center" }}
        >
            <CadastroCardNavigation color={color} onClick={onClick} data-testid={dataTestId}>
                {Icon && (
                    <IconSVG>
                        <Icon color={color} size={50} />
                    </IconSVG>
                )}
                <Text>{text}</Text>
            </CadastroCardNavigation>
        </Col>
    );
};